import { createContext } from "../../../../../../hooks/createContext";

export type GridLayoutContext = {
	rowHeaderSize: number;
	setRowHeaderSize: React.Dispatch<React.SetStateAction<number>>
}

export const [useGridLayoutContext, GridLayoutContextProvider] = createContext<GridLayoutContext>()